import React, { Component } from 'react'
import { useParams } from 'react-router-dom'

import blog1 from "../images/blog111.webp"
import blog2 from '../images/blog2222.jpg'
import blog3 from '../images/blog3333.png'
import blog4 from '../images/blog4.webp'
import logo_blog from '../images/logoblog.jpg'
import ui_ux from '../images/ui-ux.jpg'
import applications from '../images/applicationBlog.jpg'
import veb_site_services from '../images/veb_site_services.png'
import e_ticaret_saytlari from '../images/e-ticaret-vepsite.jpg'
import smm_image from '../images/smm_image.jpg'
import seo_image from '../images/seo_image.png'
import robot_image from '../images/robot.webp'

const images = {
    blog1: blog1,
    blog2: blog2,
    blog3: blog3,
    blog4: blog4,
    logo_blog: logo_blog,
    ui_ux: ui_ux,
    applications: applications,
    veb_site_services: veb_site_services,
    e_ticaret_saytlari: e_ticaret_saytlari,
    smm_image: smm_image,
    seo_image: seo_image,
    robot_image: robot_image



}

export class SingleBlog extends Component {
    render() {

        const { path } = this.props;
        const { blogs } = this.props;

        const blog = blogs.find(blog => blog.path === path);
        if (!blog) {
            return <div>Blog not found</div>;
        }

        return (
            <main>

                <section className='container pb-[32px] '>
                    <div >
                        <h2 className=" text-center text-[40px] font-[700] text-[#2e2f46] max-[1101px]:text-[30px] max-[950px]:text-[24px] max-[600px]:text-[20px] max-[400px]:text-[18px]">
                            {blog?.title}
                        </h2>
                    </div>

                    <img src={images[blog?.image]} className='mt-[20px] rounded-[8px] w-full h-[600px] max-[900px]:h-auto' />
                    <div className='flex flex-col gap-[22px] mt-[20px]'>
                        <p className='text-[#555] text-[18px] font-[400] max-[565px]:text-[16px] max-[400px]:text-[15px] blog-text'>
                            {blog?.text}
                        </p>
                    </div>
                </section>
            </main >
        )
    }
}

export default function SingleBlogWrapper(props) {
    const { path } = useParams();  // useParams ile id'yi alıyoruz
    return <SingleBlog {...props} path={path} />;
}